import React from 'react';
import { Button, Typography, RefreshIcon } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
var CardContentError = function (_a) {
    var refreshCardData = _a.refreshCardData;
    return (React.createElement(Grid, { container: true, direction: "column" },
        React.createElement(Grid, { item: true },
            React.createElement(Typography, { variant: "body1", component: "div" }, "We're having trouble loading this data.")),
        React.createElement(Grid, { item: true, container: true, direction: "row-reverse" },
            React.createElement(Grid, { item: true },
                React.createElement(Button, { size: "small", startIcon: React.createElement(RefreshIcon, { fontSize: "xsmall", color: "inherit" }), color: "vitality", onClick: refreshCardData, style: { marginLeft: 'auto' } }, "Refresh")))));
};
export default CardContentError;
